import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import './df-catalog.config';
import { RouteResource } from './route/route.resource';

export function provideDfCatalog(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAppInitializer(() => {
            inject(RouteResource).appInitialize();
        })
    ]);
}
